// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","container":"Footer_container__R7sXj","content":"Footer_content__aJpHx","poweredBy":"Footer_poweredBy__5PLma","author":"Footer_author__OoSZf"};